import Button from 'tailwind-components/Button/Button';
import React from 'react';
import propTypes from 'prop-types';
import style from './contactCard.module.scss';
import { Phone } from 'lucide-react';

function ContactCard({ info, title, hasButton = true }) {
  const isEmail = info && info.includes('@');
  const linkHref = isEmail ? `mailto:${info}` : `tel:${info}`;

  return (
    <div className={style.contactCard}>
      <h3>{title}</h3>
      <div>
        {!isEmail && (
          <a href={linkHref}>
            {hasButton ? (
              <Button
                text='call'
                size='small'
                variant='primary'
                outlined
                icon={<Phone size={20} />}
              />
            ) : null}
          </a>
        )}
        <a href={linkHref} className={isEmail ? style.emailLink : ''}>
          {info}
        </a>
      </div>
    </div>
  );
}

ContactCard.propTypes = {
  title: propTypes.string,
  info: propTypes.string,
  hasButton: propTypes.bool
};

export default ContactCard;
